document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.reviews-slider');

  sliders.forEach(slider => {
    const track = slider.querySelector('.reviews-slider__track');
    const prevBtn = slider.querySelector('.reviews-slider__nav-prev');
    const nextBtn = slider.querySelector('.reviews-slider__nav-next');

    if (!track || !prevBtn || !nextBtn) return;

    // Get width of a single slide + gap
    const getScrollAmount = () => {
      const slide = track.querySelector('.reviews-slider__slide');
      if (!slide) return 0;
      
      const slideWidth = slide.offsetWidth;
      const gap = parseInt(window.getComputedStyle(track).gap) || 0;
      
      return slideWidth + gap;
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });
    
    // Optional: disable buttons if at the end/beginning
    const updateButtons = () => {
      if (track.scrollLeft <= 0) {
        prevBtn.style.opacity = '0.5';
        prevBtn.style.cursor = 'default';
      } else {
        prevBtn.style.opacity = '1';
        prevBtn.style.cursor = 'pointer';
      }
      
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 1) {
        nextBtn.style.opacity = '0.5';
        nextBtn.style.cursor = 'default';
      } else {
        nextBtn.style.opacity = '1';
        nextBtn.style.cursor = 'pointer';
      }
    };
    
    track.addEventListener('scroll', updateButtons);
    window.addEventListener('resize', updateButtons);
    
    // Initial check
    updateButtons();
  });
});
